import { dynamicApiSlice } from "../dynamicApi";
import { buildODataQuery } from "@/helpers";
import type { ODataResponse, WorkflowDefinition } from "@/types";
import type { RichInputComponentDefinition } from "@/types/RichInputComponentDefinition";

export const workflowDefinitionsApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorkflowDefinitions: builder.query<
      WorkflowDefinition[],
      {
        filter?: string;
        select?: string[];
        expand?: string;
        top?: number;
        skip?: number;
      }
    >({
      query: (params) => `WorkflowDefinitions?${buildODataQuery(params)}`,
      transformResponse: (response: ODataResponse<Array<WorkflowDefinition>>) =>
        response.value.map((item) => ({
          ...item,
          inputs: [],
        })),
    }),

    getWorkflowDefinitionById: builder.query<
      WorkflowDefinition,
      { id: string; select?: string[]; expand?: string }
    >({
      query: ({ id, select, expand }) =>
        `WorkflowDefinitions(${id})?${buildODataQuery({ select, expand })}`,
      transformResponse: (response: WorkflowDefinition) => response,
    }),

    getWorkflowDefinitionInputs: builder.query<
      RichInputComponentDefinition[],
      { id: string }
    >({
      query: ({ id }) => `WorkflowDefinitions/${id}/inputs`,
      transformResponse: (response: RichInputComponentDefinition[]) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetWorkflowDefinitionsQuery,
  useGetWorkflowDefinitionByIdQuery,
  useGetWorkflowDefinitionInputsQuery,
  usePrefetch,
} = workflowDefinitionsApi;
